module.exports = __webpack_public_path__ + "img/logo.f9a4d22f.png";